import { render, staticRenderFns } from "./NavbarType.vue?vue&type=template&id=2fbe38da&"
import script from "./NavbarType.vue?vue&type=script&lang=js&"
export * from "./NavbarType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports